module.exports = __webpack_public_path__ + "static/media/teams.87d8d50b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/teams.png
// module id = 863
// module chunks = 6